export default [
  {
    path: '/detect-leakage/home',
    name: 'home',
    component: () => import('@/views/detect-leakage/home'),
    meta: {
      isFullPath:true,
      title: '志愿捡漏系统'
    }
  },
  {
    path: '/detect-leakage/index',
    name: 'index',
    component: () => import('@/views/detect-leakage/index'),
    meta: {
      isFullPath:true,
      title: '志愿捡漏系统'
    }
  },
]